import React from 'react';

import Alert from './components';

import { useAlert } from '../../providers/alert';

function Alerts() {
  const {
          alerts,
          hideAlert,
        } = useAlert();

  return (
    <div className={'alertContainer'}>
      {alerts.map((alert, a) => (
        <Alert
          key={a}
          index={a}
          {...alert}
          hide={() => hideAlert(alert.key)}
        />
      ))}
    </div>
  );
}

export default Alerts;